import request from '../request'

export const questionTagApi = {
  listQuestionTag (params) {
    return request.get('/v2/admin/questionTags', { params: params })
  },
  getQuestionTag (id) {
    return request.get('/v2/admin/questionTags/' + id)
  },
  saveQuestionTag (data) {
    return request.post('/v2/admin/questionTags', data)
  },
  updateQuestionTag (id, data) {
    return request.put('/v2/admin/questionTags/' + id, data)
  },
  deleteQuestionTag (id) {
    return request.delete('/v2/admin/questionTags/' + id)
  },
}

export default questionTagApi
